import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ICallDetail } from 'src/app/interfaces/icall-detail';
import { ISummaryCall } from 'src/app/interfaces/isummary-call';
@Component({
  selector: 'app-my-team-modal',
  templateUrl: './my-team-modal.component.html',
  styleUrls: ['./my-team-modal.component.scss'],
  standalone: false
})
export class MyTeamModalComponent implements OnInit {
  callDetails: ICallDetail[] = [];
  summaryCalls: ISummaryCall[] = [];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<MyTeamModalComponent>,
  ) {}

  ngOnInit(): void {
    this.callDetails = this.data.callDetails;
    this.summaryCalls = this.data.summaryCalls;
  }

  close(): void {
    this.dialogRef.close();
  }
}
